import { connect } from 'react-redux'
import { change, formValueSelector, getFormAsyncErrors } from 'redux-form'
import { convertUnicodeToLatin } from '../../../../../store/utility'
import { actionTypes, FORM_NAME } from '../../../constants'
import { getCityList } from '../../../selectors'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

const mapStateToProps = (state, { fields }) => {
  const selector = formValueSelector(FORM_NAME)
  const AsyncErrorSelector = getFormAsyncErrors(FORM_NAME)

  return {
    officialAddress: fields.Address ? selector(state, fields.Address.FName) : undefined,
    officialAddressAlt: fields.Address_ALT ? selector(state, fields.Address_ALT.FName) : undefined,
    officalCountry: selector(state, 'CountryID'),
    currentCountry: selector(state, 'Country2ID'),
    officialAddressCity: fields.CityID ? selector(state, fields.CityID.FName) : undefined,
    currentAddress: fields.Address2 ? selector(state, fields.Address2.FName) : undefined,
    currentAddressAlt: fields.Address2_ALT ? selector(state, fields.Address2_ALT.FName) : undefined,
    currentAddressCity: fields.City2ID ? selector(state, fields.City2ID.FName) : undefined,
    CardNumber: fields.CardNumber ? selector(state, fields.CardNumber.FName) : undefined,
    CellPhone: fields.CellPhone ? selector(state, fields.CellPhone.FName) : undefined,
    IDCardTypeID: fields.IDCardTypeID ? selector(state, fields.IDCardTypeID.FName) : undefined,
    Phone: fields.Phone ? selector(state, fields.Phone.FName) : undefined,
    CellPhoneValidateCode: selector(state, 'CellPhoneValidateCode'),
    CodeVerifyPass: selector(state, 'CodeVerifyPass'),
    SMSCodeSent: selector(state, 'SMSCodeSent'),
    CodeVerifyClicked: selector(state, 'CodeVerifyClicked'),
    OrgCellPhone: selector(state, 'OrgCellPhone'),
    FormAsyncErrors: AsyncErrorSelector(state),
    cityList: getCityList(state),
  }
}

const mapDispatchToProps = (dispatch, { fields }) => ({
  copyAddressFromOfficialAddress: async (address, city, country, list) => {
    const translatedAddress = await dispatch(convertUnicodeToLatin(address))
    const cities = list['CityIDList']

    dispatch({ type: actionTypes.UPDATE_CITIES_LIST, payload: { cities, fieldName: 'City2ID' } })

    dispatch(change(FORM_NAME, 'Country2ID', country))
    dispatch(change(FORM_NAME, fields.City2ID.FName, city))
    dispatch(change(FORM_NAME, 'Address2', address))
    dispatch(change(FORM_NAME, 'Address2_ALT', translatedAddress?.payload))
  },

  copyAddressFromCurrentAddress: async (address, city, country, list) => {
    const translatedAddress = await dispatch(convertUnicodeToLatin(address))
    const cities = list['City2IDList']

    dispatch({ type: actionTypes.UPDATE_CITIES_LIST, payload: { cities, fieldName: 'CityBusID' } })

    dispatch(change(FORM_NAME, 'CountryBusID', country))
    dispatch(change(FORM_NAME, 'AddressBus', address))
    dispatch(change(FORM_NAME, fields.CityBusID.FName, city))
    dispatch(change(FORM_NAME, 'AddressBus_ALT', translatedAddress?.payload))
  },
  clearCellPhoneValidateCode: () => {
    dispatch(change(FORM_NAME, 'CellPhoneValidateCode', ''))
  },
  openErrorModal: (message) => dispatch(LKModalActions.openError(message)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  CardNumber: stateProps.CardNumber,
  CellPhone: stateProps.CellPhone,
  IDCardTypeID: stateProps.IDCardTypeID,
  Phone: stateProps.Phone,
  CellPhoneValidateCode: stateProps.CellPhoneValidateCode,
  CodeVerifyPass: stateProps.CodeVerifyPass,
  SMSCodeSent: stateProps.SMSCodeSent,
  CodeVerifyClicked: stateProps.CodeVerifyClicked,
  OrgCellPhone: stateProps.OrgCellPhone,
  FormAsyncErrors: stateProps.FormAsyncErrors,

  clearCellPhoneValidateCode: () => dispatchProps.clearCellPhoneValidateCode(),
  copyAddressFromOfficialAddress: () =>
    dispatchProps.copyAddressFromOfficialAddress(
      stateProps.officialAddress,
      stateProps.officialAddressCity,
      stateProps.officalCountry,
      stateProps.cityList,
    ),

  copyAddressFromCurrentAddress: () =>
    dispatchProps.copyAddressFromCurrentAddress(
      stateProps.currentAddress,
      stateProps.currentAddressCity,
      stateProps.currentCountry,
      stateProps.cityList,
    ),
  openErrorModal: (message) => {
    dispatchProps.openErrorModal(message)
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)
